import React, { useEffect, useState } from 'react';
import axios from 'axios';
import GolfCountdown from './GolfCountdown';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const resolveImg = (src) => (!src ? '' : src.startsWith('http') ? src : `${BACKEND_URL}${src}`);

const AnnouncementBanner = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/content/banner`);
        setData(data);
      } catch (e) {
        // silent - banner is optional
      }
    })();
  }, []);

  if (!data || !data.published || !data.image) return null;

  const img = (
    <img
      src={resolveImg(data.image)}
      alt={data.alt_text || 'Announcement banner'}
      className="block w-full h-auto max-h-[30vh] md:max-h-[45vh] object-contain object-center mx-auto"
      data-testid="announcement-banner-image"
    />
  );

  // Static banner — full width across phone / laptop / desktop, height auto but
  // capped so it stays short; image wraps (contain) and is horizontally centered.
  // Countdown renders as a separate strip beneath the banner (not overlapping the image).
  return (
    <>
      <div
        className="w-full flex items-center justify-center bg-[#EAF6EA]"
        data-testid="announcement-banner"
      >
        {data.link_url ? (
          <a
            href={data.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full"
          >
            {img}
          </a>
        ) : (
          img
        )}
      </div>
      <GolfCountdown />
    </>
  );
};

export default AnnouncementBanner;
